module.exports = __webpack_public_path__ + "img/afspraak.7fe51268.png";